<ng-container>
	<base-display [smallLetters]="s()" [bigLetters]="b()" [unit]="unit()" [showScale]="showScale()" [scaleElements]="scaleElements()" [scaleType]="getScaleType()"></base-display>
</ng-container>